import {baseApi} from './baseApi';

export const injectedIsoBundeslandApi = baseApi.injectEndpoints({
    addTagTypes: ['country'],
    endpoints: (builder) => ({
        getBundesland: builder.query({
            query: (args) => {

                return {url: 'getBundeslaenderCodes'};
            },
            providesTags: ['country']
        }) ,
        getKreis: builder.query({
            query: (args) => {

                return {url: 'getKreisCodes'};
            },
            providesTags: ['country']
        }) ,
        getGemeinde: builder.query({
            query: (args) => {

                return {url: 'getGemeindeCodes'};
            },
            providesTags: ['country']
        })
    }),
});

export const {
    useGetBundeslandQuery,
    useGetKreisQuery,
    useGetGemeindeQuery,
} = injectedIsoBundeslandApi;
